"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
var _exportNames = {
  NavigationHeader: true
};
exports.NavigationHeader = void 0;
var _navigationHeader = _interopRequireDefault(require("./components/navigation-header"));
exports.NavigationHeader = _navigationHeader["default"];
var _navigationHeader2 = require("./components/navigation-header.propTypes");
Object.keys(_navigationHeader2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _navigationHeader2[key]) return;
  exports[key] = _navigationHeader2[key];
});